import { ref, isRef, unref, watchEffect  } from 'vue'
// import { useCookies } from '@vueuse/integrations/useCookies'

export function useFetch(url, body, method) {
    const data = ref(null)
    const error = ref(null)
    const headers = ref(null)
    const status = ref(null)
    const success = ref(false)

    const serverUrl = import.meta.env.VITE_API_SERVER

    // const { get } = useCookies(['XSRF-TOKEN'])
    // const token = get(['XSRF-TOKEN'])

    const myHeaders = new Headers()
    myHeaders.append("Accept", "application/json")
    myHeaders.append("Content-Type", "application/json")
    // if(token) myHeaders.append('X-CSRF-Token', token)


    const requestOptionsRef = ref({
        redirect: 'follow',
        headers: myHeaders,
        credentials: 'include'
    })



    async function doFetch() {
        data.value = null
        error.value = null

        const urlValue = unref(url)
        if (unref(method)) { requestOptionsRef.value.method = unref(method) } else { requestOptionsRef.value.method = 'GET' }
        if (unref(body) && (unref(method) === 'POST' || unref(method) === 'PUT' || unref(method) === 'PATCH')) {
            requestOptionsRef.value.body = JSON.stringify(unrefBody())
        } else if (requestOptionsRef.value.body && unref(method) === 'GET') {
            delete requestOptionsRef.value.body
        }

        const requestOptions = unref(requestOptionsRef)
        try {
            const res = await fetch(serverUrl + urlValue, requestOptions)
            headers.value = (res.headers)
            status.value = res.status
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                data.value = await res.json()
            }
            if(res.ok) {
                success.value = true
            }

            return Promise.resolve()
        } catch (e) {
            error.value = e
            console.error(serverUrl + urlValue)
            console.error(e)
        }
    }

    function unrefBody() {
        let unrefBody = {... unref(body)};
        if (typeof unrefBody === 'object') {
            for (const key in body) {
                unrefBody[key] = unref(unrefBody[key])
            }
        }
        return unrefBody
    }

    let promise = null

    if (isRef(url)) {
        // setup reactive re-fetch if input URL is a ref
        watchEffect(()=> promise = doFetch())
    } else {
        // otherwise, just fetch once
        promise = doFetch()
    }

    return { data, error, headers, status, retry: doFetch, promise, success }
}

